/*
 * @LastEditors: caobopan
 * @LastEditTime: 2022-12-14 12:23:18
 * @Description: feature页面
 * @FilePath: /starmaker-starvr-officialnew/src/pages/home/components/bottomtab/index.js
 */

import {
  Link
} from "react-router-dom";
import './index.scss';

const BottomBar = (props) => {
  return (
    <div className={`bottom-box absolute bottom-0 z-20 w-full ${props.showBottomTab ? 'show' : ''}`}>
      <div className={`Bottombar w-full absolute bottom-0 h-48 border-t-4 `}>
        <p className='pt-16 font-bold text-center text-white'>COPYRIGHT © STAR SHINE ENTERTAINMENT PTE LTD</p>
        <p className='pt-2 text-center text-indigo-500'>
          <span className='inline-block pr-5' >
            <Link className="bar-link" target='_blank' to="/doc?type=0" >Privacy Policy</Link>
          </span>
          <span className='inline-block'>
            <Link className="bar-link" target='_blank' to="/doc?type=1" >Terms of Service</Link>
          </span>
        </p>
        <div className='absolute cursor-pointer close-btn right-5 -top-12' onClick={props.close}></div>
      </div>
    </div>
  );
}

export default BottomBar;
